import {
  USER_ADD_USER,
  USER_ADD_USER_COMPLETED,
  USER_ADD_USER_FAILED,
  USER_CHANGE_PASSWORD,
  USER_CHANGE_PASSWORD_COMPLETED,
  USER_CHANGE_PASSWORD_FAILED,
  USER_GET_USER,
  USER_GET_USER_COMPLETED,
  USER_GET_USER_FAILED,
  USER_GET_USERS,
  USER_GET_USERS_COMPLETED,
  USER_GET_USERS_FAILED,
  USER_UPDATE_USER,
  USER_UPDATE_USER_COMPLETED,
  USER_UPDATE_USER_FAILED
} from "./actions";

const defaultState = Object.freeze({
  addingUser: false,
  updatingUser: false,
  changingPassword: false,
  error: null,
  users: [],
  usersLoading: false,
  usersPagination: {pageSize: 8, current: 1},
  user: null,
  userLoading: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case USER_ADD_USER: {
      return {
        ...state,
        changingPassword: true,
        error: null,
      };
    }
    case USER_ADD_USER_COMPLETED: {
      return {
        ...state,
        changingPassword: false,
      };
    }
    case USER_ADD_USER_FAILED: {
      return {
        ...state,
        changingPassword: false,
        error: action.payload,
      };
    }
    case USER_UPDATE_USER: {
      return {
        ...state,
        updatingUser: true,
        error: null,
      };
    }
    case USER_UPDATE_USER_COMPLETED: {
      return {
        ...state,
        updatingUser: false,
      };
    }
    case USER_UPDATE_USER_FAILED: {
      return {
        ...state,
        updatingUser: false,
        error: action.payload,
      };
    }
    case USER_CHANGE_PASSWORD: {
      return {
        ...state,
        changingPassword: true,
        error: null,
      };
    }
    case USER_CHANGE_PASSWORD_COMPLETED: {
      return {
        ...state,
        changingPassword: false,
      };
    }
    case USER_CHANGE_PASSWORD_FAILED: {
      return {
        ...state,
        changingPassword: false,
        error: action.payload,
      };
    }
    case USER_GET_USERS: {
      return {
        ...state,
        usersLoading: true,
        users: [],
        error: null,
      };
    }
    case USER_GET_USERS_COMPLETED: {
      return {
        ...state,
        usersLoading: false,
        users: action.payload.data,
      };
    }
    case USER_GET_USERS_FAILED: {
      return {
        ...state,
        usersLoading: false,
        error: action.payload,
      };
    }
    case USER_GET_USER: {
      return {
        ...state,
        userLoading: true,
        user: null,
        error: null,
      };
    }
    case USER_GET_USER_COMPLETED: {
      return {
        ...state,
        userLoading: false,
        user: action.payload,
      };
    }
    case USER_GET_USER_FAILED: {
      return {
        ...state,
        userLoading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/User/reducer.js